module.exports = __webpack_public_path__ + "img/dgbank.13fc6b76.jpg";